import React from "react";
import { BrowserRouter, Routes, Route, Link, useLocation } from "react-router-dom";
import { ToastProvider } from "./components/Toast";
import ProtectedRoute from "./components/ProtectedRoute";
import { useAuth } from "./contexts/AuthContext";
import DashboardPage from "./pages/DashboardPage";
import PantryPage from "./pages/PantryPage";
import ShoppingListPage from "./pages/ShoppingListPage";

const Navigation = () => {
  const location = useLocation();
  const { user, signOut } = useAuth();

  const isActive = (path) => {
    return location.pathname === path
      ? "text-purple-700 font-semibold border-b-2 border-purple-500"
      : "text-gray-600 hover:text-purple-600";
  };

  return (
    <nav className="bg-white shadow-md mb-4">
      <div className="max-w-6xl mx-auto px-4 py-3">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="flex space-x-1 sm:space-x-4">
            <Link
              to="/"
              className={`px-3 py-2 text-sm sm:text-base ${isActive("/")}`}
            >
              Spending Dashboard
            </Link>
            <Link
              to="/pantry"
              className={`px-3 py-2 text-sm sm:text-base ${isActive("/pantry")}`}
            >
              Pantry
            </Link>
            <Link
              to="/shopping-list"
              className={`px-3 py-2 text-sm sm:text-base ${isActive("/shopping-list")}`}
            >
              Shopping List
            </Link>
          </div>
          {user && (
            <div className="flex items-center gap-3">
              {user.photoURL && (
                <img
                  src={user.photoURL}
                  alt=""
                  className="h-8 w-8 rounded-full"
                />
              )}
              <span className="text-sm text-gray-600 hidden sm:inline">
                {user.displayName || user.email}
              </span>
              <button
                type="button"
                onClick={signOut}
                className="text-sm text-gray-600 hover:text-purple-600"
              >
                Sign out
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

const App = () => {
  return (
    <ToastProvider>
      <BrowserRouter>
        <ProtectedRoute>
          <div className="min-h-screen bg-gray-50">
            <Navigation />
            <Routes>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/pantry" element={<PantryPage />} />
              <Route path="/shopping-list" element={<ShoppingListPage />} />
            </Routes>
          </div>
        </ProtectedRoute>
      </BrowserRouter>
    </ToastProvider>
  );
};

export default App;
